import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ButtonIconTrashForever } from '@adflow/frontend/ui-buttons';
import { ModalDialog } from '@adflow/frontend/ui-modal';

export function ColumnTemplateDeleteButton({
	name,
	deleteColumnTemplate,
}: {
	name: string | undefined;
	deleteColumnTemplate: () => void;
}) {
	const { t } = useTranslation('common');

	const [showDelete, setShowDelete] = useState(false);

	return (
		<>
			<ButtonIconTrashForever
				onClick={() => setShowDelete(true)}
				css={{
					marginLeft: -4,
					minWidth: 0,
					height: 40,
				}}
			/>

			{showDelete ? (
				<ModalDialog
					show
					type="archive"
					onCancel={() => setShowDelete(false)}
					headerContent={
						<Trans
							ns="common"
							i18nKey="columnTemplate.deleteConfirmDialog.header"
						/>
					}
					bodyContent={
						<Trans
							ns="common"
							i18nKey="columnTemplate.deleteConfirmDialog.body"
							values={{ name }}
						/>
					}
					confirmButtonContent={t('buttons.delete')}
					onConfirm={() => deleteColumnTemplate()}
				/>
			) : null}
		</>
	);
}
